import { useEffect } from "react";

const DEFAULT_TITLE = "Studio Skandal — Przestrzeń Eventowa w Centrum Warszawy";
const DEFAULT_DESCRIPTION = "Studio Skandal – 400 m², 3 poziomy, pełna prywatność. Eventy, imprezy firmowe, sesje foto w centrum Warszawy.";

interface SEOHeadProps {
  title: string;
  description: string;
}

const SEOHead = ({ title, description }: SEOHeadProps) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);

    return () => {
      document.title = DEFAULT_TITLE;
      const meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", DEFAULT_DESCRIPTION);
    };
  }, [title, description]);

  return null;
};

export default SEOHead;
